import { AmbientLight, MathUtils, Scene, Vector3 } from "three";
import { MouseEvents } from "../../../componets3D/MouseEvents";
import { CameraController } from "../../../componets3D/CameraController";
// import { Floor } from "../objects/Floor";
import { MapSubtopicTwo } from "../../objects/Tema1/subtopicTwo/MapSubtopicTwo";
import ObserverEmitter, { EVENTS } from "../../../../emitter/Observer";
import { HandHeld } from "../../objects/Tema1/subtopicFive/HandHeld";
import { CharcterOxxo } from "../../objects/CharacterOxxo";

export class SceneTopicFive extends Scene {
	constructor(loadingManager, container, render, character = new CharcterOxxo(), enviroment) {
		super();
		this.camera = new CameraController();
		this.environment = enviroment;
		this.characterSelected = character;
		this.loadingManager = loadingManager;
		this.mouseEvents = new MouseEvents(container, render, this.camera, this);
		this.create();
		this.light();
		// this.helper();
		this.renderAnimations();
		this.observerListeners();
	}
	create() {
		this.add(this.characterSelected);

		this.mapmenu = new MapSubtopicTwo(this.loadingManager);
		this.add(this.mapmenu);

		this.handheld = new HandHeld(this.camera);

		// this.floor = new Floor(this.loadingManager);
		// this.add(this.floor);
	}

	SceneInitialState() {
		this.mouseEvents.disposeInteractions();
	}

	activeAudio() {
		ObserverEmitter.emit(EVENTS.audioInitByTopic)
	}

	ActivitiSelected(activity) {
		switch (activity) {
			case 0:
				this.camera.moveCameraToPoint(new Vector3(-10.883, 2.298, -2.2733), 1, new Vector3(-10.005, -0.371, -1.869), () => {
					this.camera.control.maxPolarAngle = MathUtils.degToRad(100);
					this.camera.control.minPolarAngle = MathUtils.degToRad(20);
					this.camera.control.enableRotate = false;
					this.camera.control.maxAzimuthAngle = -0.86;
					this.camera.control.minAzimuthAngle = -2;
					this.camera.control.minDistance = 1;
					this.camera.control.maxDistance = 3;
					this.camera.control.enablePan = false;
					this.activeAudio()
				});
				break;
			case 1:
				// posicion refri 2
				this.handheld.visible = false
				this.camera.moveCameraToPoint(new Vector3(-8.6844, -1.4505, -3.7758), 1, new Vector3(-5.691, -1.415, -3.58), () => {
					this.camera.control.maxPolarAngle = MathUtils.degToRad(100);
					this.camera.control.minPolarAngle = MathUtils.degToRad(20);
					this.camera.control.enableRotate = false;
					this.camera.control.maxAzimuthAngle = Infinity;
					this.camera.control.minAzimuthAngle = Infinity;
					this.camera.control.minDistance = 1;
					this.camera.control.minAzimuthAngle = -1.126;
					this.camera.control.minDistance = 1;
					this.camera.control.maxDistance = 3;
					this.camera.control.enablePan = false;

					this.characterSelected.visible = true;
					this.characterSelected.onAnimationFestejo();
					this.characterSelected.position.set(-6.6545, -1.7849, -3.5857);
					this.characterSelected.rotation.y = -1.6466;

					this.handheld.visible = false

					this.activeAudio()

				});
				break;

			default:
				// posicion escritorio 1
				this.camera.control.maxAzimuthAngle = Infinity;
				this.camera.control.minAzimuthAngle = Infinity;
				this.camera.moveCameraToPoint(new Vector3(-12.5158, -0.2328, -1.8734), 1, new Vector3(-11.493, -0.366, -1.905), () => {
					this.camera.control.maxPolarAngle = MathUtils.degToRad(100);
					this.camera.control.minPolarAngle = MathUtils.degToRad(20);
					this.camera.control.enableRotate = false;
					this.camera.control.maxAzimuthAngle = -0.86;
					this.camera.control.minAzimuthAngle = -2;
					this.camera.control.minDistance = 1;
					this.camera.control.maxDistance = 3;
					this.camera.control.enablePan = false;

					this.characterSelected.visible = false
					this.activeAudio()
				});
				break;
		}
	}

	light() {
		this.ambient = new AmbientLight();
		this.ambient.color.set(0xffffff);
		this.ambient.intensity = 1;
		this.add(this.ambient);
	}

	observerListeners() {
		ObserverEmitter.on(EVENTS.subtopicFive.activityOne.moveToInvetary, () => {
			this.camera.control.maxAzimuthAngle = Infinity;
			this.camera.control.minAzimuthAngle = Infinity;
			this.camera.moveCameraToPoint(new Vector3(-0.2486, -0.0183, -1.2903), 1, new Vector3(-0.242, -0.345, -0.164), () => {
				this.camera.control.maxPolarAngle = MathUtils.degToRad(100);
				this.camera.control.minPolarAngle = MathUtils.degToRad(20);
				this.camera.control.enableRotate = false;
				this.camera.control.maxAzimuthAngle = -2.288;
				this.camera.control.minAzimuthAngle = -3.788;
				this.camera.control.minDistance = 1;
				this.camera.control.maxDistance = 3;
				this.camera.control.enablePan = false;
			});
		});

		ObserverEmitter.on(EVENTS.subtopicFive.activityOne.visibleHandler, () => {
			this.handheld.visible = true
			this.add(this.handheld);
		});

		ObserverEmitter.on(EVENTS.subtopicFive.activityOne.moveToPositionInit, () => {
			this.camera.control.maxAzimuthAngle = Infinity;
			this.camera.control.minAzimuthAngle = Infinity;
			this.handheld.visible = false
			this.camera.moveCameraToPoint(new Vector3(-8.6844, -1.4505, -3.7758), 1, new Vector3(-5.691, -1.415, -3.58), () => {
				this.camera.control.maxPolarAngle = MathUtils.degToRad(100);
				this.camera.control.minPolarAngle = MathUtils.degToRad(20);
				this.camera.control.enableRotate = false;
				this.camera.control.maxAzimuthAngle = Infinity;
				this.camera.control.minAzimuthAngle = Infinity;
				this.camera.control.minDistance = 1;
				// this.camera.control.minAzimuthAngle = -1.126;
				// this.camera.control.minDistance = 1;
				this.camera.control.maxDistance = 3;
				this.camera.control.enablePan = false;

				this.characterSelected.visible = true;
				this.characterSelected.onAnimationFestejo();
				this.characterSelected.position.set(-6.6545, -1.7849, -3.5857);
				this.characterSelected.rotation.y = -1.6466;

			});
		});
	}

	renderAnimations(delta) {
		this.handheld.renderAnimations(delta);
	}
}
